import { html } from "lit";
import { AnNamElement } from "../../base-element";

export class AnStickyCart extends AnNamElement {
  private observer: IntersectionObserver | null = null;
  private visible = false;
  private productFormButton: HTMLButtonElement | null = null;

  connectedCallback(): void {
    super.connectedCallback();
    this.productFormButton = document.querySelector(
      'product-info .product-form__submit'
    );
    if (!this.productFormButton) return;

    this.observer = new IntersectionObserver(
      ([entry]) => {
        this.visible = !entry.isIntersecting;
        this.requestUpdate();
      },
      { threshold: 0.15 }
    );

    this.observer.observe(this.productFormButton);
  }

  disconnectedCallback(): void {
    this.observer?.disconnect();
    super.disconnectedCallback();
  }

  render() {
    if (!this.productFormButton || !this.visible) return html``;

    return html`
      <div class="an-sticky-cart-bar">
        <button class="button button--primary" @click=${this.scrollToForm}>Add to cart</button>
      </div>
    `;
  }

  private scrollToForm = (): void => {
    this.productFormButton?.scrollIntoView({ behavior: "smooth", block: "center" });
    this.productFormButton?.focus();
  };
}

if (!customElements.get("an-sticky-cart")) {
  customElements.define("an-sticky-cart", AnStickyCart);
}
